module.exports = __webpack_public_path__ + "resources/img/img_secureguard3_m.88e6bb95db98b847e7636de52726ceef.png";